import React from "react";
import { Button } from "UI/atoms";
import deleteIcon from "shared/images/card-delete.svg";
import editIcon from "shared/images/card-edit.svg";
import addIcon from "shared/images/card-add.svg";
import { Spinner } from "shared/assets/svgs";

const BoxProducts = ({
  elements,
  title,
  endpoint,
  openModal,
  selectItem,
  selectItemId,
  deleteItem,
  loadingData,
}) => {
  const item = elements?.find((obj) => obj.id === selectItemId);

  return (
    <div className="col">
      <h4>{title}</h4>
      <div className="card">
        <ul>
          {loadingData ? (
            <div className="spinner-items-ajustes">
              <Spinner />
            </div>
          ) : (
            elements?.map((element) => (
              <li
                key={element.id}
                onClick={() => selectItem(element.id)}
                className={selectItemId === element.id ? "selected" : null}
              >
                {element.name || element.name_plural}
              </li>
            ))
          )}
          {elements.length === 0 && (
            <span className="no_items_ajustes">No hay items</span>
          )}
        </ul>
      </div>
      <ul className="card-foot">
        <li>
          <Button
            width="auto"
            height="auto"
            borderRadius="0"
            background="transparent"
            fontSize="1.4em"
            onClick={() => deleteItem(endpoint, item)}
            className={Boolean(item) ? null : "btn-disabled"}
            disabled={!item}
          >
            <img src={deleteIcon} width="22" alt="Eliminar" />
            Eliminar
          </Button>
        </li>
        <li>
          <Button
            width="auto"
            height="auto"
            borderRadius="0"
            background="transparent"
            fontSize="1.4em"
            onClick={() => openModal(title, endpoint, "edit")}
            className={item ? null : "btn-disabled"}
            disabled={!item}
          >
            <img src={editIcon} width="22" alt="Editar" />
            Editar
          </Button>
        </li>
        <li>
          <Button
            width="auto"
            height="auto"
            borderRadius="0"
            background="transparent"
            fontSize="1.4em"
            onClick={() => openModal(title, endpoint, "add")}
          >
            <img src={addIcon} width="22" alt="Agregar" />
            Agregar
          </Button>
        </li>
      </ul>
    </div>
  );
};

export default BoxProducts;
